<template>
  <div class="h-18 w-full flex items-center justify-between px-8 py-3 bg-slate-100 z-10">
    <slot></slot>
  </div>
</template>
